module.exports = __webpack_public_path__ + "media/images/reviews/trust_pilot-f2fc26af9296f95bcefe829241eb084f.svg";